import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-full-screen-overflow',
  templateUrl: './full-screen-overflow.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./full-screen-overflow.component.scss'],
})
export class FullScreenOverflowComponent {
    message = input.required<string>();
}
